import { render, staticRenderFns } from "./AssignServicesToCompaniesView.vue?vue&type=template&id=04636ec2&"
import script from "./AssignServicesToCompaniesView.vue?vue&type=script&lang=ts&"
export * from "./AssignServicesToCompaniesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports